import { empty, singleton, append, ofArray } from "../fable-library.3.1.4/List.js";
import { Types_RequestProperties } from "../Fable.Fetch.2.4.0/Fetch.fs.js";
import { some, defaultArg } from "../fable-library.3.1.4/Option.js";
import { obj_type, class_type } from "../fable-library.3.1.4/Reflection.js";
import { Fetch_tryDelete_5760677E, Fetch_delete_5760677E, Fetch_tryPatch_5760677E, Fetch_patch_5760677E, Fetch_tryPut_5760677E, Fetch_put_5760677E, Fetch_tryPost_5760677E, Fetch_post_5760677E, Fetch_tryFetchAs_25B10BBE, Fetch_fetchAs_25B10BBE } from "../Thoth.Fetch.2.0.0/Fetch.fs.js";
import { uncurry } from "../fable-library.3.1.4/Util.js";

export function ServicesFramework_moduleHeaders(sf) {
    return ofArray([["ModuleId", sf.getModuleId()], ["TabId", sf.getTabId()], ["RequestVerificationToken", sf.getAntiForgeryValue()]]);
}

export function ServicesFramework_setup$0027(isGet, moduleId, moduleName, url, props) {
    const sf = window['$'].ServicesFramework(moduleId);
    const serviceroot = sf.getServiceRoot(moduleName);
    const props_1 = append(singleton(new Types_RequestProperties(4, "same-origin")), defaultArg(props, empty()));
    const Url = serviceroot + url;
    return {
        Headers: ServicesFramework_moduleHeaders(sf),
        Props: props_1,
        Url: Url,
    };
}

export const ServicesFramework_setup = (moduleId) => ((moduleName) => ((url) => ((props) => ServicesFramework_setup$0027(false, moduleId, moduleName, url, props))));

export class Fetch {
    constructor() {
    }
}

export function Fetch$reflection() {
    return class_type("Dnn.Fable.Fetch", void 0, Fetch);
}

export function Fetch_fetchAs_511FB67E(moduleId, moduleName, url, properties, caseStrategy, extra, responseResolver) {
    const sf = ServicesFramework_setup$0027(true, moduleId, moduleName, url, properties);
    return Fetch_fetchAs_25B10BBE(sf.Url, uncurry(2, void 0), void 0, void 0, sf.Props, sf.Headers, caseStrategy, extra, responseResolver, {
        ResolveType: () => obj_type,
    });
}

export function Fetch_tryFetchAs_511FB67E(moduleId, moduleName, url, properties, caseStrategy, extra, responseResolver) {
    const sf = ServicesFramework_setup$0027(true, moduleId, moduleName, url, properties);
    return Fetch_tryFetchAs_25B10BBE(sf.Url, uncurry(2, void 0), void 0, void 0, sf.Props, sf.Headers, caseStrategy, extra, responseResolver, {
        ResolveType: () => obj_type,
    });
}

export function Fetch_get_511FB67E(moduleId, moduleName, url, properties, caseStrategy, extra, responseResolver) {
    return Fetch_fetchAs_511FB67E(moduleId, moduleName, url, properties, caseStrategy, extra, responseResolver);
}

export function Fetch_tryGet_511FB67E(moduleId, moduleName, url, properties, caseStrategy, extra, responseResolver) {
    return Fetch_tryFetchAs_511FB67E(moduleId, moduleName, url, properties, caseStrategy, extra, responseResolver);
}

export function Fetch_post_3817AB3A(moduleId, moduleName, url, data, properties, caseStrategy, extra, responseResolver, dataResolver) {
    const sf = ServicesFramework_setup(moduleId)(moduleName)(url)(properties);
    return Fetch_post_5760677E(sf.Url, some(data), sf.Props, sf.Headers, caseStrategy, extra, uncurry(2, void 0), responseResolver, dataResolver);
}

export function Fetch_tryPost_3817AB3A(moduleId, moduleName, url, data, properties, caseStrategy, extra, responseResolver, dataResolver) {
    const sf = ServicesFramework_setup(moduleId)(moduleName)(url)(properties);
    return Fetch_tryPost_5760677E(sf.Url, some(data), sf.Props, sf.Headers, caseStrategy, extra, uncurry(2, void 0), responseResolver, dataResolver);
}

export function Fetch_put_3817AB3A(moduleId, moduleName, url, data, properties, caseStrategy, extra, responseResolver, dataResolver) {
    const sf = ServicesFramework_setup(moduleId)(moduleName)(url)(properties);
    return Fetch_put_5760677E(sf.Url, some(data), sf.Props, sf.Headers, caseStrategy, extra, uncurry(2, void 0), responseResolver, dataResolver);
}

export function Fetch_tryPut_3817AB3A(moduleId, moduleName, url, data, properties, caseStrategy, extra, responseResolver, dataResolver) {
    const sf = ServicesFramework_setup(moduleId)(moduleName)(url)(properties);
    return Fetch_tryPut_5760677E(sf.Url, some(data), sf.Props, sf.Headers, caseStrategy, extra, uncurry(2, void 0), responseResolver, dataResolver);
}

export function Fetch_patch_3817AB3A(moduleId, moduleName, url, data, properties, caseStrategy, extra, responseResolver, dataResolver) {
    const sf = ServicesFramework_setup(moduleId)(moduleName)(url)(properties);
    return Fetch_patch_5760677E(sf.Url, some(data), sf.Props, sf.Headers, caseStrategy, extra, uncurry(2, void 0), responseResolver, dataResolver);
}

export function Fetch_tryPatch_3817AB3A(moduleId, moduleName, url, data, properties, caseStrategy, extra, responseResolver, dataResolver) {
    const sf = ServicesFramework_setup(moduleId)(moduleName)(url)(properties);
    return Fetch_tryPatch_5760677E(sf.Url, some(data), sf.Props, sf.Headers, caseStrategy, extra, uncurry(2, void 0), responseResolver, dataResolver);
}

export function Fetch_delete_3817AB3A(moduleId, moduleName, url, data, properties, caseStrategy, extra, responseResolver, dataResolver) {
    const sf = ServicesFramework_setup(moduleId)(moduleName)(url)(properties);
    return Fetch_delete_5760677E(sf.Url, some(data), sf.Props, sf.Headers, caseStrategy, extra, uncurry(2, void 0), responseResolver, dataResolver);
}

export function Fetch_tryDelete_3817AB3A(moduleId, moduleName, url, data, properties, caseStrategy, extra, responseResolver, dataResolver) {
    const sf = ServicesFramework_setup(moduleId)(moduleName)(url)(properties);
    return Fetch_tryDelete_5760677E(sf.Url, some(data), sf.Props, sf.Headers, caseStrategy, extra, uncurry(2, void 0), responseResolver, dataResolver);
}

